import { render, staticRenderFns } from "./authGroup.vue?vue&type=template&id=fd6627d6&scoped=true&"
import script from "./authGroup.vue?vue&type=script&lang=js&"
export * from "./authGroup.vue?vue&type=script&lang=js&"
import style0 from "./authGroup.vue?vue&type=style&index=0&id=fd6627d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6627d6",
  null
  
)

export default component.exports